import ConsentsHome from './ConsentsHome';
import ConsentTerm from './ConsentTerm';
import { Box } from '@mui/material';

export interface ConsentAppRouterProps {
  termKey?: string;
}

export const ConsentAppRouter = ({ termKey }: ConsentAppRouterProps) => {
  if (!termKey) {
    return (
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <ConsentsHome />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }}
    >
      <ConsentTerm termKey={termKey} />
    </Box>
  );
};
